import {lastUpdateInit} from "./util";

const domain = document.getElementsByTagName('meta').apiDomain.content;

export default {

  // #### login url
  login: `${domain}login`,
  loginInfo: `${domain}login/info`,
  checkMfa: `${domain}login/checkMfa`,
  status: `${domain}status`,
  corpDivision: `${domain}corp/division`,
  corpList: `${domain}corp/list`,
  corpListIncludeMSP: `${domain}corp/list/msp/include`,
  idInfo: `${domain}login/idInfo`,


  // #### login passwordReset url
  loginPasswordResetMail: `${domain}login/password/resetMail`,
  loginPasswordReset: `${domain}login/password/reset`,


  // #### accountSetting password reSetting url
  usersPassword: `${domain}users/password`,


  // #### accountSetting MFA url
  userMfa: `${domain}users/mfa`,
  userMfaGenerateSecret: `${domain}users/mfa/generateSecret`,

  // #### invoice url
  invoiceDivisionCorpYear: `${domain}invoice/division/corp/year`,
  invoiceCorp: `${domain}invoice/corp`,
  invoiceCorpTrend: `${domain}invoice/corp/trend`,
  invoiceDivisionAccountYear: `${domain}invoice/division/account/year`,
  invoiceAccount: `${domain}invoice/account`,
  invoiceAccountTrend: `${domain}invoice/account/trend`,
  billingDownloadInvoicePdf: `${domain}/billing/download/invoice/pdf`,
  billOfChargesDivisionMonth: `${domain}billing/billOfCharges/division/month`,
  billOfChargesSignedUrl: `${domain}billing/billOfCharges/signedUrl`,
  invoiceCurHistory: `${domain}invoiceCurHistory`,
  resellerBillOfChargesDivisionMonth: `${domain}reseller/billOfCharges/division/month`,
  resellerBillOfChargeSimpleCorpList: `${domain}reseller/billOfCharges/simpleCorpList`,
  billOfChargeSimpleCorpList: `${domain}saltManager/billOfCharges/simpleCorpList`,
  billingBillOfChargePagination: `${domain}billing/billOfCharges/corpList/pagination`,
  saltManagerBillOfChargePagination: `${domain}saltManager/billOfCharges/corpList/pagination`,
  resellerBillOfChargePagination: `${domain}reseller/billOfCharges/corpList/pagination`,
  invoiceDetailDownloadXlsx: `${domain}invoice/detail/download/xlsx`,


  // #### billing url
  ondemandDivisionMonth: `${domain}ondemand/division/month`,
  ondemandDivisionDay: `${domain}ondemand/division/day`,
  ondemandCorpMonth: `${domain}ondemand/corp/month`,
  ondemandCorpDay: `${domain}ondemand/corp/day`,
  ondemandAccountDay: `${domain}ondemand/account/day`,
  ondemandAccountMonth: `${domain}ondemand/account/month`,
  ondemandCorpDayTrend: `${domain}ondemand/corp/dayTrend`,
  ondemandCorpMonthTrend: `${domain}ondemand/corp/monthTrend`,
  ondemandAccountDayTrend: `${domain}ondemand/account/dayTrend`,
  ondemandAccountMonthTrend: `${domain}ondemand/account/monthTrend`,
  tagsDivision: `${domain}tags/division`,
  tagsDivisionAccount: `${domain}tags/division/account`,
  tagsFind: `${domain}tags/find`,
  tagsFindAccount: `${domain}tags/find/account`,
  tagkeyList: `${domain}tag/keys/list`,
  tagList: `${domain}tag/list`,
  tagDetailByMonth: `${domain}trend/month/tag/detail`,
  tagDetailByDay: `${domain}trend/day/tag/detail`,

  // # Recommendation URL
  costUtilizationRi: `${domain}costUtilization/ri`,
  costUtilizationRiUsageTrend: `${domain}costUtilization/ri/usageTrend`,
  costUtilizationRiOptions: `${domain}costUtilization/ri/options`,
  costUtilizationSavingsPlan: `${domain}costUtilization/savingsPlan`,
  costUtilizationSavingsPlanUsageTrend: `${domain}costUtilization/savingsPlan/usageTrend`,
  costUtilizationSavingsPlanOptions: `${domain}costUtilization/savingsPlan/options`,

  // # RI --------------------------
  riCorpDayTrend: `${domain}ri/corp/dayTrend`,
  riAccountMonth: `${domain}ri/account/month`,
  riAccountDay: `${domain}ri/account/day`,
  riCorpMonthTrend: `${domain}ri/corp/monthTrend`,
  riAccountDayTrend: `${domain}ri/account/dayTrend`,
  riAccountMonthTrend: `${domain}ri/account/monthTrend`,
  riDivisionDay: `${domain}ri/division/day`,
  riDivisionMonth: `${domain}ri/division/month`,
  riCorpMonth: `${domain}ri/corp/month`,
  riCorpDay: `${domain}ri/corp/day`,
  riDivisionServiceMonth: `${domain}ri/coverage/division/service`,
  riCoverageTrendMonth: `${domain}ri/coverage/monthly/trend`,
  riCoverageSummaryMonth: `${domain}ri/coverage/monthly/summary`,
  riCoverageTrendDay: `${domain}ri/coverage/daily/trend`,
  riCoverageSummaryDay: `${domain}ri/coverage/daily/summary`,


  // # CF --------------------------
  cfDivisionDay: `${domain}cf/division/day`,
  cfDivisionMonth: `${domain}cf/division/month`,
  cfCorpMonth: `${domain}cf/corp/month`,
  cfCorpMonthLatest: `${domain}cf/corp/month/latest`,
  cfAccountMonthLatest: `${domain}cf/account/month/latest`,
  cfCorpDay: `${domain}cf/corp/day`,
  cfCorpMonthTrend: `${domain}cf/corp/monthTrend`,
  cfCorpDayTrend: `${domain}cf/corp/dayTrend`,
  cfCorpHourlyDataTransfer: `${domain}cf/corp/hourly/dataTransfer`,
  cfAccountDay: `${domain}cf/account/day`,
  cfAccountMonth: `${domain}cf/account/month`,
  cfAccountMonthTrend: `${domain}cf/account/monthTrend`,
  cfAccountDayTrend: `${domain}cf/account/dayTrend`,
  cfAccountHourlyDataTransfer: `${domain}cf/account/hourly/dataTransfer`,
  cfUsageTrend: `${domain}cf/usageTrend`,
  cfAccountUsageTrend: `${domain}cf/usageTrend/account`,
  cfScoreBoard: `${domain}cf/scoreboard`,
  cfAccountScoreBoard: `${domain}cf/scoreboard/account`,
  cfDistributionList: `${domain}cf/distributionList`,
  cfDistributionGroupList: `${domain}cf/distributionGroup`,
  cfDistributionTotalSelect: `${domain}cf/distributionTotalSelect`,
  cfDistributionGroupSelect:`${domain}cf/distributionGroupSelect`,
  cfDistribution: `${domain}cf/distribution/distribution`,
  cfGroupCheck: `${domain}cf/distribution/groupCheck`,
  cfCostDiscountByRegion: `${domain}cf/costAndDiscount/region`,
  cfAccountCostDiscountByRegion: `${domain}cf/costAndDiscount/region/account`,
  cfCostDiscountByAccount: `${domain}cf/costAndDiscount/account`,

  cfOndemandList: `${domain}cf/ondemand/list`,


  // # Dashboard --------------------------
  dashboardScoreBoard: `${domain}dashboard/scoreBoard`,
  dashboardDataTransfer: `${domain}dashboard/dataTransfer`,
  dashboardPriceRankingMap: `${domain}dashboard/priceRankingMap`,
  dashboardServicePriceRanking: `${domain}dashboard/servicePriceRanking`,
  accountDashboardScoreBoard: `${domain}dashboard/scoreBoard/account`,
  accountDashboardServicePriceRanking: `${domain}dashboard/servicePriceRanking/account`,
  accountDashboardPriceRankingMap: `${domain}dashboard/priceRankingMap/account`,


  // # ServiceTrend --------------------------
  serviceTrendCorpMonth: `${domain}service/trend/corp/month`,
  serviceTrendCorpDay: `${domain}service/trend/corp/day`,
  serviceTrendAccountMonth: `${domain}service/trend/account/month`,
  serviceTrendAccountDay: `${domain}service/trend/account/day`,
  serviceTrendTypeFilter: `${domain}service/trend/type-filter`,



  // alarm
  reportBudgetList: `${domain}report/budget/list`,
  reportBudget: `${domain}report/budget`,


  // Notification
  notificationCostIncrease: `${domain}notification/costIncrease`,
  notificationCostIncreaseList: `${domain}notification/costIncrease/list`,
  notificationBudget: `${domain}notification/budget`,
  notificationBudgetList: `${domain}notification/budget/list`,
  notificationHistoryList: `${domain}/notification/history/list`,
  notificationRiUsageInfo: `${domain}notification/ri/info`,
  notificationRiUnusedExclude: `${domain}/notification/ri/unused/exclude`,

  // Payer
  payers: `${domain}payers`,

  // #### CORP / USER INFO
  corp: `${domain}corp`,
  corpCf: `${domain}corp/cf`,
  corpAddInfo: `${domain}corp/addInfo`,
  corpCreditSharingFlag: `${domain}corp/credit-sharing-flag`,
  customer: `${domain}corp/customer` ,
  infoMailList: `${domain}info/mail/list`,
  creditTotal: `${domain}corp/credit/total`,
  corpAccountId:`${domain}corp/accountId`,
  slackUrlForNotification: `${domain}corp/notification/slack-url`,
  corpBillingAccount: `${domain}corp/billingAccount`,

  // # CORP / RESELLER INFO
  resellerList: `${domain}reseller/list`,
  resellerOrg: `${domain}reseller/org`,
  resellerCorp: `${domain}reseller/corp`,
  resellerScoreBoard: `${domain}reseller/scoreBoard/`,
  resellerCorpCostInfoByMonth: `${domain}reseller/cost-info/`,

  // # SWITCH ROLE
  switchRole: `${domain}switch-role`,
  switchRoleLogInsert: `${domain}switch-role/log`,
  headerSwitchRoleLogInsert: `${domain}header/switch-role/log`,
  headerSwitchRole: `${domain}header/switch-role`,

  // # Account
  account: `${domain}account`,
  accountIdsCorp: `${domain}/account/list`,
  accountInfo: `${domain}account/info`,
  accountList: `${domain}accountList`,
  accountSupport: `${domain}account/support`,
  accountCrossAccountCheck: `${domain}account/crossAccount/check`,
  accountAddInfo: `${domain}account/accountAddInfo`,
  accountAddInfoList: `${domain}account/accountAddInfo/list`,


  // #Price
  cfPrice: `${domain}cf/price`,
  cfPriceList: `${domain}cf/price/list`,


  // ###Discount/Surcharge
  discountClosingStatusInvoiceCount: `${domain}discount/closing-status/invoice/count`,
  discount: `${domain}discount`,
  discountItem: `${domain}discount/item`,
  discountDeletable: `${domain}discount/deletable`,
  discountUsage: `${domain}discount/usage`,
  discountUsageList: `${domain}discount/usage/list`,
  surcharge: `${domain}surcharge`,
  surchargeInfo: `${domain}surcharge/info`,
  surchargeDeletable: `${domain}surcharge/deletable`,

  code: `${domain}code`,
  regions: `${domain}regions`,
  corpCaseDescribe: `${domain}corpCaseDescribe`,


  // ### mailSend
  mailType: `${domain}mail/type`,
  invoiceMailStatus: `${domain}invoice/mail/status`,
  invoiceGeneratePdf: `${domain}invoice/generatePdf`,
  invoiceSendInvoice: `${domain}invoice/sendInvoice`,
  invoiceSendImminent: `${domain}invoice/sendImminent`,
  invoiceSendReminder: `${domain}invoice/sendReminder`,
  invoiceUnpaidCorpList: `${domain}invoice/unpaid/corpList`,


  // ### msp
  saltwareMsp: `${domain}saltware/msp`,
  saltwarePriceMsp: `${domain}saltwarePrice/msp`,
  saltwarePriceMspInfo: `${domain}saltwarePrice/msp/info`,

  // ### 환율조회
  exchange: `${domain}exchange`,
  exchangeRate: `${domain}exchangeRate`,

  // ### 자원 현황
  resourceInfo: `${domain}resources/info`,

  // ### RI
  riEc2: `${domain}ri/ec2`,
  riRds: `${domain}ri/rds`,
  riOpensearch: `${domain}ri/opensearch`,
  riElasticache: `${domain}ri/elasticache`,
  riRedshift: `${domain}ri/redshift`,


  // # savingsPlans Corp Division--------------------------
  savingsPlan: `${domain}savingsPlan`,
  savingsPlanEc2DivisionMonth: `${domain}savingsPlan/ec2/division/month`,
  savingsPlanEc2DivisionDay: `${domain}savingsPlan/ec2/division/day`,
  savingsPlanComputeDivisionMonth: `${domain}savingsPlan/compute/division/month`,
  savingsPlanComputeDivisionDay: `${domain}savingsPlan/compute/division/day`,


  // # savingsPlans Corp selectData--------------------------
  savingsPlanEc2CorpMonth: `${domain}savingsPlan/ec2/corp/month`,
  savingsPlanEc2CorpDay: `${domain}savingsPlan/ec2/corp/day`,
  savingsPlanComputeCorpMonth: `${domain}savingsPlan/compute/corp/month`,
  savingsPlanComputeCorpDay: `${domain}savingsPlan/compute/corp/day`,


  // # savingsPlans Account selectData--------------------------
  savingsPlanEc2AccountMonth: `${domain}savingsPlan/ec2/account/month`,
  savingsPlanEc2AccountDay: `${domain}savingsPlan/ec2/account/day`,
  savingsPlanComputeAccountMonth: `${domain}savingsPlan/compute/account/month`,
  savingsPlanComputeAccountDay: `${domain}savingsPlan/compute/account/day`,

  // # SavingsPlans(SP) Trend Data
  savingsPlansCorpMonthTrend: `${domain}sp/corp/monthTrend`,
  savingsPlansCorpDayTrend: `${domain}sp/corp/dayTrend`,
  savingsPlansAccountMonthTrend: `${domain}sp/account/monthTrend`,
  savingsPlansAccountDayTrend: `${domain}sp/account/dayTrend`,

  // # 단독 Payer를 위한 AWS 사용률
  savingsPlansAWSUtilization: `${domain}aws/savings-plans/utilization`,
  savingsPlansAWSUtilizationDetails: `${domain}aws/savings-plans/utilizationDetails`,

  // # IVS
  ivsCorpMonthTrend: `${domain}ivs/corp/monthTrend`,
  ivsCorpDayTrend: `${domain}ivs/corp/dayTrend`,
  ivsAccountMonthTrend: `${domain}ivs/account/monthTrend`,
  ivsAccountDayTrend: `${domain}ivs/account/dayTrend`,

  // ### Pivot
  resourceServiceCorpMonth: `${domain}pivot/resource/service/corp/month`,
  resourceServiceAccountMonth: `${domain}pivot/resource/service/account/month`,
  pivotDivisionKeyMonth: `${domain}tags/division/key/month`,
  pivotDivisionKeyAccountMonth : `${domain}tags/division/key/account/month`,
  resourceServiceAccountDay: `${domain}pivot/resource/service/account/day`,
  tagDivisionMonth: `${domain}tags/division/month`,
  tagDivisionAccountMonth : `${domain}tags/division/account/month`,
  pivotMonth: `${domain}pivot/data/month`,
  pivotDay: `${domain}pivot/data/day`,


  // ### Spot Summary
  spotMonthly: `${domain}/spot/monthly`,
  spotMonthlyDetail: `${domain}spot/monthly/detail`,
  spotDaily: `${domain}spot/daily`,
  spotDailyDetail: `${domain}spot/daily/detail`,

  spotAccountMonthly: `${domain}/spot/account/monthly`,
  spotAccountMonthlyDetail: `${domain}spot/account/monthly/detail`,
  spotAccountDaily: `${domain}spot/account/daily`,
  spotAccountDailyDetail: `${domain}spot/account/daily/detail`,

  // ### Client
  clientCorp: `${domain}client/corp`,
  clientCorpAddInfo: `${domain}client/corp/addInfo`,


  // ### Users
  user: `${domain}user`,
  clientUser: `${domain}client/user`,
  userCorp: `${domain}user/corp`,
  userChk: `${domain}users/checkDuplicate`,
  userAccountId:`${domain}user/accountId`,

  // UA users
  limitUserConvertAuth:`${domain}user/permissions`,
  userConvertLimitUser:`${domain}user/convert/auth/limitUser`,
  limitUserChangeAll:`${domain}user/convert/info`,
  userAuth: `${domain}user/auth`,
  limitUser: `${domain}user/limit`,
  uaMappedAccountOnLogin: `${domain}ua/mappedAccount/onLogin`,
  userToken: `${domain}user/token`,

  // SPP Discount
  sppDiscountMonthly: `${domain}sppDiscount/monthly`,


  // ### saltware
  saltwareManager: `${domain}saltware/managers`,
  saltwareTechSupport: `${domain}saltware/tech-support`,
  downloadExcelUsageBillingReport: `${domain}saltManager/billingReport/excel/download`,
  createExcelUsageBillingReport: `${domain}saltManager/billingReport/excel/create`,


  // ### docs
  guide: `${domain}guide`,
  releaseNotes: `${domain}corp/release-notes`,
  releaseNotesSaltware: `${domain}admin/release-notes`,

  // ### Support Center
  caseHistory: `${domain}saltManager/support/case-history`,
};
